<template>
  <div>
    <div class="row col-md-12" style="margin: -3px 0 0 0;  border-bottom: 1px solid #93a8d6;">
      <div class="form-group mb-0 ml-1">
        <ul class="nav nav-pills" role="tablist" id="tabs" style="font-size: 14px; font-weight: 500">
          <li class="nav-item type1 mr-4">
            <a class="nav-link demo px-4" v-bind:class="[selectTab == 'all' ? 'active' : '']" href="javascript:void(0);"
              v-on:click="selTabe('all')" @click="demotabs('all')">All</a>
          </li>
          <li class="nav-item type1 mr-4">
            <a class="nav-link demo" v-bind:class="[selectTab == 0 ? 'active' : '']" href="javascript:void(0);"
              v-on:click="selTabe(0)" @click="demotabs(0)">Discovery</a>
          </li>
          <li class="nav-item type2 mr-4">
            <a class="nav-link demo" v-bind:class="[selectTab == 1 ? 'active' : '']" href="javascript:void(0);"
              v-on:click="selTabe(1)" @click="demotabs(1)">Qualified</a>
          </li>
          <li class="nav-item type3 mr-4">
            <a class="nav-link demo" v-bind:class="[selectTab == 3 ? 'active' : '']" href="javascript:void(0);"
              v-on:click="selTabe(3)" @click="demotabs(3)">Rejected</a>
          </li>
          <li class="nav-item type3 mr-4">
            <a class="nav-link demo" v-bind:class="[selectTab == 2 ? 'active' : '']" href="javascript:void(0);"
              v-on:click="selTabe(2)" @click="demotabs(2)">Dead</a>
          </li>
          
          <li class="nav-item type3 mr-4">
            <a class="nav-link demo" v-bind:class="[selectTab == 4 ? 'active' : '']" href="javascript:void(0);"
             v-on:click="selTabe(4)" @click="demotabs(4)">OnBoarding</a>
          </li>
          <li class="nav-item type3 mr-4">
            <a class="nav-link demo" v-bind:class="[selectTab == 5 ? 'active' : '']" href="javascript:void(0);"
             v-on:click="selTabe(5)" @click="demotabs(5)">OnBoarded</a>
          </li>
        </ul>
      </div>
      <div class="float-right ml-auto" style="margin-top: 6px">
        <!-- Search -->
        <div class="float-left mr-3" v-if="$can('lead_search')">
          <div class="has-search">
            <span class="fa fa-search form-control-feedback"></span>
            <input v-model="search" @keyup="demosBySearch" type="text" style="background-color: #edf2f5"
              class="form-control demo-search" placeholder="Search Here..." />
          </div>
        </div>
        <!-- End -->
        <button @click="createDemo" type="button" class="btn btn-sm float-right ml-2 add-lead" style="
          color: white;
          padding: 5px 10px;
          cursor: pointer;
          border: 1px solid #48a6a6;
          padding: 7px 8px 3px 9px;
        " v-if="$can('lead_create')">
          <span class="fa fa-plus" style="font-size:18px;color:#48a6a6;"></span>
        </button>
        <!-- <div class="form-group mb-4" style="float: right; margin-left: 120px"> -->
          <download-excel id="excel" class="btn btn-sm btn-outline-light color-default" style="
              border: 1px solid #48a6a6;
              padding: 6px 7px 2px 7px;
              margin-right: 6px;
              cursor: pointer;
            " :name="excelFileName" :data="demoRequestsArray" :fields="json_fields">
              <i class="fa fa-file-excel-o" style="font-size:19px"></i>
          </download-excel>
        <!-- </div> -->
        <!-- Filter Button-->
        <button class="btn btn-sm filter" style="border: 1px solid #48a6a6;padding: 5px 7px 2px 8px;" type="button" data-toggle="collapse"
          data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"  v-on:click="ShowFilter" v-if="$can('lead_filter')"> 
          <i class="fa fa-filter" style="font-size:19px;color:#48a6a6;"></i>
          <!-- <i class="fa fa-filter fa-lg py-1 icon bg-default"></i> -->
          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" >
            <path
              d="M14.7358 0.484375H1.26203C1.03869 0.484375 0.824497 0.573097 0.666571 0.731024C0.508644 0.88895 0.419922 1.10314 0.419922 1.32649V3.50756C0.419922 3.94798 0.599292 4.38083 0.910873 4.69241L5.47259 9.25413V15.6424C5.47276 15.7859 5.50954 15.9269 5.57946 16.0522C5.64937 16.1775 5.75011 16.2829 5.87213 16.3583C5.99414 16.4338 6.13341 16.4769 6.27673 16.4835C6.42005 16.4901 6.56268 16.46 6.69113 16.3961L10.0596 14.7119C10.3451 14.5687 10.5253 14.2773 10.5253 13.9582V9.25413L15.087 4.69241C15.3986 4.38083 15.5779 3.94798 15.5779 3.50756V1.32649C15.5779 1.10314 15.4892 0.88895 15.3313 0.731024C15.1734 0.573097 14.9592 0.484375 14.7358 0.484375ZM9.08778 8.31012C9.00943 8.38819 8.94729 8.48098 8.90494 8.58316C8.8626 8.68534 8.84088 8.79489 8.84104 8.90549V13.4377L7.15682 14.2799V8.90549C7.15698 8.79489 7.13526 8.68534 7.09291 8.58316C7.05057 8.48098 6.98843 8.38819 6.91008 8.31012L2.10415 3.50756V2.1686H13.8946L13.8962 3.50166L9.08778 8.31012Z"
              fill="#48a6a6" />
          </svg> -->
        </button>
        <!-- End -->
      </div>
    </div>
    <!-- Filter button body-->
    <div :class="show_filter" class="row collapse mx-0 mt-0 filter-button" id="collapseExample">
      <!-- <div class="col-md-4 loading-sm-parent">
              <div class="m-form__group m-form__group--inline">
                  <div class="m-form__label">
                      <label   label>Request Date Range:</label>
                  </div>
                  <select class="demo-date" v-model="selectedRangeType"
                      @change="(event) => { dateRangeChanged(event.target.value,selectTab) }">
                      <option v-for="(option, value) in rangeTypeOptions" :key="value">{{ option }}
                      </option>
                  </select>
              </div>
          </div> -->
      <div class="col-2" v-if="$can('lead_filter_followup_date_range') && (selectTab == 1 || selectTab == 'all')">
        <label class="color-default" style="font-weight: 600; font-size: 14px">Followup Date Range</label>
        <multiselect  @input="shortTerm($event)" placeholder='Follow-up range' :options="short_term_filter" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" v-model="select_followUp"
        label="name" track-by="value" style="font-size:12px !important">
        </multiselect>
      </div>
       <div class="col-2" v-if="select_followUp.value === 12 || select_followUp.name === 'Custom Date'">
        <label class="color-default" style="font-weight: 600; font-size: 14px">From</label>
        <input type="date" style="font-size: medium;" class="form-control" v-model="fromDate" >
      </div>
      <div class="col-2" v-if="select_followUp.value === 12 || select_followUp.name === 'Custom Date'">
        <label class="color-default" style="font-weight: 600; font-size: 14px">To</label>
        <input type="date" style="font-size: medium;" class="form-control" v-model="toDate" @input="applyFilter">
      </div>

      <div class="col-2" v-if="$can('lead_filter_followup_date_range')">
        <label class="color-default" style="font-weight: 600; font-size: 14px">Lead Type</label>
        <multiselect  @input="leadType($event)" placeholder='All' :options="lead_filter" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" v-model="select_leadtype"
        label="name" track-by="value" style="font-size:12px !important">
        </multiselect>
        <!-- <select v-on:change="shortTerm($event)" class="form-control demo-date" v-model="select_followUp">
          <option class="dropdown-item" value="all">All</option>
          <option class="dropdown-item" value="0">Short Term Followups</option>
          <option class="dropdown-item" value="1">Long Term Followups</option>
        </select> -->
      </div>
      <div class="col-2" v-if="$can('lead_filter_select_priority')">
        <label class="color-default" style="font-weight: 600; font-size: 14px">Select Priority</label>
        <multiselect  @input="changeColor($event)" placeholder='All' :options="priority" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" v-model="select_priority"
        label="name" track-by="value" style="font-size:12px !important">
        </multiselect>
        <!-- <select v-on:change="changeColor($event)" style="margin-bottom:9px" class="form-control demo-date" v-model="select_priority">
          <option class="dropdown-item" value="">All</option>
          <option class="dropdown-item" style="color: #66b34e" value="66b34e">
            Highly interested
          </option>
          <option class="dropdown-item" style="color: #f19a16" value="f19a16">
            Interested
          </option>
          <option class="dropdown-item" style="color: #e95a42" value="e95a42">
            Less interested
          </option>
        </select> -->
      </div>
      <div class="col-2" v-if="$can('lead_filter_demo_status')">
        <label class="color-default" style="font-weight: 600; font-size: 14px">Demo Status</label>
        <multiselect  @input="demoSchedule($event)" placeholder='All' :options="demo_schedule" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" v-model="select_demo"
          label="name" track-by="value" style="font-size:12px !important">
        </multiselect>
        <!-- <select v-on:change="demoSchedule($event)" class="form-control demo-date" v-model="select_demo">
          <option class="dropdown-item" style="width: 190px; height: 30px" value="all">
            All
          </option>
          <option class="dropdown-item" style="width: 190px; height: 30px" value="0">
            Not Schedule
          </option>
          <option class="dropdown-item" style="width: 190px; height: 30px" value="1">
            Demo Schedule
          </option>
          <option class="dropdown-item" style="width: 190px; height: 30px" value="2">
            Completed
          </option>
        </select> -->
      </div>

          <div class="col-2" v-if="selectTab != 4 && software_filter_flag">
            <label class="color-default" style="font-weight: 600; font-size: 14px">Software</label>
            <multiselect  @input="software($event)" placeholder='All' :options="lead_software" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" v-model="select_software"
              label="name" track-by="value" style="font-size:12px !important">
            </multiselect>
            <!-- <select v-on:change="software($event)" class="form-control demo-date" v-model="select_software">
              <option class="dropdown-item" style="width: 190px; height: 30px" value="all">
                All
              </option>
              <option class="dropdown-item" style="width: 190px; height: 30px" value="0">
                LinenTech
              </option>
              <option class="dropdown-item" style="width: 190px; height: 30px" value="1">
                TheStaffer
              </option>
            </select> -->
          </div>
          <div class="col-2" v-if="$can('lead_filter_tags')">
            <label class="color-default" style="font-weight: 600; font-size: 14px">Tags:</label>
            <multiselect  @input="leadTags($event)" v-model="selected_tags" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true"
             label="tag" track-by="id" :options="tag_options" placeholder="All"></multiselect>
          </div>


          <!-- Assigned Filter -->
      <div class="col-2" v-if="$can('lead_filter_assigned')">
        <label class="color-default" style="font-weight: 600; font-size: 14px">Assigned:</label>
        <multiselect  @input="assignedLeads" :value="select_assigned"  placeholder='All' :options="adminUsers"  v-model="select_assigned" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true"
        label="full_name"  track-by="id" style="font-size:12px !important">
        </multiselect>
        <!-- <select v-on:change="assignedLeads($event)" class="form-control demo-date" v-model="select_assigned">
          <option class="dropdown-item" style="width: 190px; height: 30px" value="all">
            All
          </option>
          <option v-for="item in adminUsers" v-bind:key="item.id" :value="item.id">
               {{ item.first_name }} {{item.last_name}}
           </option>
        </select> -->
      </div>
      <!-- Assigned Filter -->

    </div>
  </div>
</template>
<script>
  import moment from "moment";
  import Vue from "vue";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import axios from 'axios';
  import Multiselect from "vue-multiselect";
  import DemoForm from "../components/users/demo_form.vue"; 
  import VueSkeletonLoader from 'skeleton-loader-vue';
  import {hasPermission} from "../utils/permissions";
  Vue.use(Loading);

  var cancel;
  
  export default {
    components: {
      Multiselect,VueSkeletonLoader,
    },
    data() {
      return {
        product: 0,
        show_filter: false,
        fullPage: true,
        status: 'all',
        selectTab: 'all',
        filterIcon: 1,
        color: "",
        selected: "",
        fromDate: '',
        toDate: '',
        select_followUp:[],
        select_leadtype:[],
        select_priority:[],
        select_demo: [],
        selected_tags:[],
        select_assigned:  [],
        select_software:[],
        awaitingSearch: false,
        filter_event:{},
        rangeTypeOptions: {
          all: 'all',
          short_term: "Short Term Followup",
          long_term: "Long Term Followup",
          yesterday: "Yesterday",
          today: "Today",
          thisweek: "This Week",
          nextweek: "Next Week",
          lastweek: "Last Week",
          thismonth: "This Month",
          nextmonth: "Next Month",
          lastmonth: "Last Month",
          last3months: "Last 3 Months",
          last6months: "Last 6 Months",
          custom: "Custom Range...",
        },
        colorOptions: {
          white: "white",
          mediumseagreen: "mediumseagreen",
          chartreuse: "chartreuse",
          orange: "orange",
        },
        selectedRangeType: null,
        selectedRangeType1: null,
        request_from: "",
        request_to: "",
        follow_up_from: "",
        follow_up_to: "",
        search: "",
        results: "",
        adminUsers: [],
        role_id:'',
        uprms:'',
        selected_page: 1,
    short_term_filter: [
        { name: "Today", start_date: moment().format('YYYY-MM-DD'), end_date: moment().format('YYYY-MM-DD'), value: "0" },
        { name: "Yesterday", start_date: moment().subtract(1, 'days').format('YYYY-MM-DD'), end_date: moment().subtract(1, 'days').format('YYYY-MM-DD'), value: "1" },
        { name: "Tomorrow", start_date: moment().add(1, 'days').format('YYYY-MM-DD'), end_date: moment().add(1, 'days').format('YYYY-MM-DD'), value: "2" },
        { name: "Last week", start_date: moment().subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD'), end_date: moment().subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD'), value: "3" },
        { name: "This week", start_date: moment().startOf('isoWeek').format('YYYY-MM-DD'), end_date: moment().endOf('isoWeek').format('YYYY-MM-DD'), value: "4" },
        { name: "Next week", start_date: moment().add(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD'), end_date: moment().add(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD'), value: "5" },
        { name: "Last Month", start_date: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), end_date: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'), value: "6" },
        { name: "This Month", start_date: moment().startOf('month').format('YYYY-MM-DD'), end_date: moment().endOf('month').format('YYYY-MM-DD'), value: "7" },
        { name: "Next Month", start_date: moment().add(1, 'months').startOf('month').format('YYYY-MM-DD'), end_date: moment().add(1, 'months').endOf('month').format('YYYY-MM-DD'), value: "8" },
         { name: "Last Year", start_date: moment().subtract(1, 'years').startOf('year').format('YYYY-MM-DD'), end_date: moment().subtract(1, 'years').endOf('year').format('YYYY-MM-DD'), value: "9" },
        { name: "This Year", start_date: moment().startOf('year').format('YYYY-MM-DD'), end_date: moment().endOf('year').format('YYYY-MM-DD'), value: "10" },
        { name: "Next Year", start_date: moment().add(1, 'years').startOf('year').format('YYYY-MM-DD'), end_date: moment().add(1, 'years').endOf('year').format('YYYY-MM-DD'), value: "11" },
        { name: "Custom Date", start_date: "", end_date: "", value: "12" }

        ],
        lead_filter:[
           { name:'All' , value:'all'},
           { name: 'outbound', value: '1' },
           { name: 'inbound', value: '2' },
        ],
        priority: [
          {name:"All", value:"all"},
          {name:"Highly interested", value:"66b34e"},
          {name:"Interested", value:"f19a16"},
          {name:"Less interested", value:"e95a42"},
        ],
        demo_schedule: [
          {name:"All", value:"all"},
          {name:"Not Schedule", value:"0"},
          {name:"Demo Schedule", value:"1"},
          {name:"Completed", value:"2"},
          {name:"InComplete" , value:"3"}
        ],
        lead_software: [
          {name:"All", value:"all"},
          {name:"LinenTech", value:"0"},
          {name:"TheStaffer", value:"1"},
        ],
        skeletonLoader: false,
        userPro:[],
        software_filter_flag: true,
        tag_options:{},
        demoRequestsArray:{},
        excelFileName:"lead.xls",
        json_fields: {
          Company: "company",
          Name: "name",
          Phone: "phone",
          Email: "email",
          Country: "country",
          "Request At": "created_at",
          Implementation: "implement_date",
          "Demo Date": "demo_date_note",
          "Followup Date": "followup_date",
          "Estimated Value": "estimated_value",
          Status: "status",
          Status: {
            field: "status",
            callback: (value) => {
              if (value == 'all') {
                return `All`;
              } else if (value == 0) {
                return `Discovery`;
              } else if (value == 1) {
                return `Qualified`;
              } else if (value == 2) {
                return `Dead`;
              } else if (value == 3) {
                return `Rejected`;
              } else if (value == 4) {
                return `OnBoarding`;
              }
            },
          },
        }
        // availableProducts:[],
        // availablePro:[],
        // activeProducts: {},

      };
    },
    props: ["filter", "page","userProducts", "products","tags","demoRequests"],
    created: function () {


        this.select_followUp  = this.short_term_filter[10];
        this.shortTerm(this.short_term_filter[10]);


      this.tag_options = this.tags;
      if(this.tag_options.length>0){
        if(this.tag_options['0']['id'] != 'all'){
          this.tag_options.unshift({
            tag: "All",
            id: "all",
          });
        }
      }else{
        this.tag_options.unshift({
            tag: "All",
            id: "all",
          });
      }
      
      this.role_id = localStorage.getItem('role');
      this.role_id == 2 && this.userProducts.length > 1 ? this.software_filter_flag = true: this.software_filter_flag= false;
      if(hasPermission('lead_list')){
        const permission = {
          headers: {
            'X-Permission': 'lead_list'
          }
        };
        axios.get('/admin/users/get-all-users?role_id=' + 2,permission)
            .then((response) => {
              let res = response.data;
              this.adminUsers = res.data;
              this.adminUsers.unshift({
                full_name: "All",
                id: "all",
              });
            });
      }

      // this.select_demo = localStorage.getItem('demo_filter');
      this.show_filter = localStorage.getItem('show_filter');
      // this.show_filter = false;
      // this.select_software = localStorage.getItem('software_filter');
      if (localStorage.getItem("tab") != null) {
        this.selectTab = localStorage.getItem("tab");
      } else {
        this.selectTab = 'all';
      }
    },
    computed: function () {
      
      this.select_demo = localStorage.getItem('demo_filter');
      this.show_filter = localStorage.getItem('show_filter');
      this.select_software = localStorage.getItem('software_filter');
      if (localStorage.getItem("tab") != null) {
        this.selectTab = localStorage.getItem("tab");
      } else {
        this.selectTab = 'all';
      }
    },

    mounted() {
      this.demoRequestsArray =  this.demoRequests;
      this.selected_page = this.page;
      this.userPro = this.userProducts;
      this.product = localStorage.getItem('product');
      if (this.filter == "nextweek") {
        this.selectedRangeType1 = "nextweek";
        this.followUpRangeChanged("nextweek", 9);
      }
      $("body").on("click", ".nav-item", function () {
        $(".demo-date").val(null);
        $(".search").val(null);
      });
    },
    watch:{
      demos: function () {
        this.demoRequestsArray = this.demoRequests;
        return this.demoRequestsArray;
      },
    },
    methods: {
      applyFilter(e) {
        console.log(e.target.value);
        this.shortTerm(this.filter_event,this.fromDate, this.toDate);
        const permission = {
      headers: {
        'X-Permission': 'lead_list' 
      }
    };
        },

    
      calculateRangeForType(rangeType) {
        switch (rangeType) {
          case "short_term":
            return {
              from: " ",
              to: " ",
            };
          case "yesterday":
            return {
              from: moment().subtract(1, "day").startOf("day").toDate(),
              to: moment().subtract(1, "day").startOf("day").toDate(),
            };

          case "today":
            return {
              from: moment().startOf("day").toDate(),
              to: moment().endOf("day").toDate(),
            };

          case "thisweek":
            return {
              from: moment().startOf("isoWeek").toDate(),
              to: moment().endOf("isoWeek").toDate(),
            };

          case "lastweek":
            return {
              from: moment().subtract(1, "isoWeek").startOf("isoWeek").toDate(),
              to: moment().subtract(1, "isoWeek").endOf("isoWeek").toDate(),
            };
          case "nextweek":
            return {
              from: moment().add(1, "isoWeek").startOf("isoWeek").toDate(),
              to: moment().add(1, "isoWeek").endOf("isoWeek").toDate(),
            };

          case "thismonth":
            return {
              from: moment().startOf("month").toDate(),
              to: moment().endOf("month").toDate(),
            };

          case "nextmonth":
            return {
              from: moment().add(1, "month").startOf("month").toDate(),
              to: moment().add(1, "month").endOf("month").toDate(),
            };
          case "lastmonth":
            return {
              from: moment().subtract(1, "month").startOf("month").toDate(),
              to: moment().subtract(1, "month").endOf("month").toDate(),
            };

          case "last3months":
            return {
              from: moment().subtract(3, "month").startOf("month").toDate(),
              to: moment().endOf("month").toDate(),
            };

          case "last6months":
            return {
              from: moment().subtract(6, "month").startOf("month").toDate(),
              to: moment().endOf("month").toDate(),
            };
          case 9:
            return {
              from: " ",
              to: " ",
            };
          default:
            return null;
        }
      },
      ShowFilter(){
        this.show_filter == 'show' ?  localStorage.setItem('show_filter', false) :  localStorage.setItem('show_filter', 'show');
      },
      dateRangeChanged(rangeType, selectTab) {
        if (this.selectedRangeType === "custom") {
          if (this.request_from == null || this.request_to == null) {
            return;
          } else {
            let dateRange = {
              from: moment(this.request_from).startOf("day").toDate(),
              to: moment(this.request_to).endOf("day").toDate(),
            };
            let request_from = moment(String(dateRange.from)).format(
              "YYYY-MM-DD"
            );
            let request_to = moment(String(dateRange.to)).format("YYYY-MM-DD");
            this.request_from = request_from;
            this.request_to = request_to;

            this.demoStatus(selectTab);
            this.$emit("input", dateRange);
          }
        } else {
          let dateRange = this.calculateRangeForType(rangeType);
          if (dateRange.from == " " || dateRange.to == " ") {
          } else if (dateRange.from == " " || dateRange.to == " ") {
            let request_from = "";
            let request_to = "";
            this.request_from = request_from;
            this.request_to = request_to;
          } else {
            let request_from = moment(String(dateRange.from)).format(
              "YYYY-MM-DD"
            );
            let request_to = moment(String(dateRange.to)).format("YYYY-MM-DD");
            this.request_from = request_from;
            this.request_to = request_to;
          }
          this.demoStatus(selectTab);
          this.$emit("input", dateRange);
        }
      },
      followUpRangeChanged(rangeType, selectTab) {
        if (this.selectedRangeType1 === "custom") {
          if (this.follow_up_from == null || this.follow_up_to == null) {
            return;
          } else {
            let dateRange = {
              from: moment(this.follow_up_from).startOf("day").toDate(),
              to: moment(this.follow_up_to).endOf("day").toDate(),
            };
            let follow_up_from = moment(String(dateRange.from)).format(
              "YYYY-MM-DD"
            );
            let follow_up_to = moment(String(dateRange.to)).format("YYYY-MM-DD");
            this.follow_up_from = follow_up_from;
            this.follow_up_to = follow_up_to;

            this.demoStatus(selectTab);
            this.$emit("input", dateRange);
          }
        } else {
          let dateRange = this.calculateRangeForType(rangeType);
          if (dateRange.from == " " || dateRange.to == " ") {
            let follow_up_from = "";
            let follow_up_to = "";
            this.follow_up_from = follow_up_from;
            this.follow_up_to = follow_up_to;
          } else {
            let follow_up_from = moment(String(dateRange.from)).format(
              "YYYY-MM-DD"
            );
            let follow_up_to = moment(String(dateRange.to)).format("YYYY-MM-DD");
            this.follow_up_from = follow_up_from;
            this.follow_up_to = follow_up_to;
          }
          this.demoStatus(selectTab);
          this.$emit("input", dateRange);
        }
      },
      demoStatus(status) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.skeletonLoader = true;
        this.$emit("skeletonLoader", this.skeletonLoader);
        let self = this;
        localStorage.removeItem("direction");
        localStorage.setItem("demo_filter", 'all');
        this.$emit("assigned_filter", 'all');
        this.$emit("crm_id", 0);
        this.$emit("changeColor", '');
        this.$emit("setStatus", status);
        this.$store
          .dispatch("users/getAllDemoRequests", [
            this.selected_page,
            "",
            status,
            self.request_from,
            self.request_to,
            self.follow_up_from,
            self.follow_up_to,
            "",
            "",
            "",
            'all',
            'all',
            'all'
          ])
          .then(() => {
              this.skeletonLoader = false;
              this.$emit("skeletonLoader", this.skeletonLoader);
          });
        this.selectTab = status;

        // setTimeout(() => loader.hide(), 1 * 300)
      },
      shortTerm(event,fromDate = '', toDate = '') {
        this.filter_event = event;
        this.skeletonLoader = true;
        this.$emit("skeletonLoader", this.skeletonLoader);
        this.$emit("assigned_filter", 'all');
        this.$emit("crm_id", 0);
        this.$emit("changeColor", '');
        this.search = '';
        this.select_assigned = [];
        this.select_leadtype=[];
        this.select_demo = [];
        this.select_software = [];
        let selected_lead_tag = 0;
        selected_lead_tag = (this.selected_tags['id'] == 'all'  || this.selected_tags['id'] === undefined) ?  0:  this.selected_tags['id'];
        this.select_priority.value == "all" ? this.select_priority.value = '' : '';
        let followup_filter = event.value;
        if(followup_filter == ''){
          followup_filter = 'all';
        }
        localStorage.removeItem("direction");
        localStorage.setItem("demo_filter", 'all');
        
        this.$emit("selecttabe", this.selectTab);
        this.$emit("followupFilter", followup_filter);
        if (followup_filter === '12') {
        fromDate = this.fromDate;
        toDate = this.toDate;
      } else {
        const selectedRange = this.short_term_filter.find(range => range.value === followup_filter);
        fromDate = selectedRange.start_date;
        toDate = selectedRange.end_date;
      }
      this.fromDate = fromDate;
      this.toDate = toDate ;

        this.$store.dispatch("users/getAllDemoRequests", [
           1,
            "",
            this.selectTab,
            self.request_from,
            self.request_to,
            self.follow_up_from,
            self.follow_up_to,
            "",
            "",
            this.select_priority.value,
            followup_filter,
            'all',
            'all',
            'all',
            '',
            selected_lead_tag,
            fromDate,
            toDate

          ])
          .then(() => {
              this.skeletonLoader = false;
              this.$emit("skeletonLoader", this.skeletonLoader);
          });

        this.$emit('setDateFilters', fromDate,toDate);
      },
       leadType(event) {
        this.skeletonLoader = true;
        this.$emit("skeletonLoader", this.skeletonLoader);
        this.$emit("assigned_filter", 'all');
        this.$emit("crm_id", 0);
        this.$emit("changeColor", '');
        this.search = '';
        this.select_assigned = [];
        this.select_followUp = [];
        this.select_demo = [];
        this.select_software = [];
        let selected_lead_tag = 0;
        selected_lead_tag = (this.selected_tags['id'] == 'all'  || this.selected_tags['id'] === undefined) ?  0:  this.selected_tags['id'];
        this.select_priority.value == "all" ? this.select_priority.value = '' : '';
        let lead_filter = event.name;
        localStorage.removeItem("direction");
        localStorage.setItem("demo_filter", 'all');
        this.$emit("selecttabe", this.selectTab);
        this.$store
          .dispatch("users/getAllDemoRequests", [
           1,
            "",
            this.selectTab,
            self.request_from,
            self.request_to,
            self.follow_up_from,
            self.follow_up_to,
            "",
            "",
            this.select_priority.value,
            'all',
            'all',
            'all',
            'all',
            '',
            selected_lead_tag,
            '',
            '',
            lead_filter,
          ])
          .then(() => {
              this.skeletonLoader = false;
              this.$emit("skeletonLoader", this.skeletonLoader);
          });
      },
      demoSchedule(event) {
        this.skeletonLoader = true;
        this.$emit("skeletonLoader", this.skeletonLoader);
        localStorage.removeItem("direction");
        this.$emit("assigned_filter", 'all');
        this.$emit("crm_id", 0);
        this.$emit("changeColor", '');
        this.$emit("followupFilter", 'all');
        this.select_followUp = [];
        this.select_leadtype=[];
        this.search = '';
        this.select_priority = [];
        this.select_software = [];
        let selected_lead_tag = 0;
        selected_lead_tag = (this.selected_tags['id'] == 'all'  || this.selected_tags['id'] === undefined) ?  0:  this.selected_tags['id'];
        let self = this;
        let demo_filter = event.value;
        this.select_assigned = [];
        localStorage.setItem('software_filter', 'all');
        localStorage.setItem("demo_filter", demo_filter);
        this.$emit("selecttabe", this.selectTab);
        this.$store
          .dispatch("users/getAllDemoRequests", [
            1,
            "",
            this.selectTab,
            self.request_from,
            self.request_to,
            self.follow_up_from,
            self.follow_up_to,
            "",
            "",
            "",
            'all',
            demo_filter,
            'all',
            'all',
            '',
            selected_lead_tag
          ])
          .then( () => {
            this.skeletonLoader = false;
            this.$emit("skeletonLoader", this.skeletonLoader);
          });
      },


      assignedLeads(event) {
        this.skeletonLoader = true;
        this.$emit("skeletonLoader", this.skeletonLoader);
        localStorage.removeItem("direction");
        this.search = '';
        this.select_followUp = [];
        this.select_demo = [];
        this.select_software = [];
        this.select_leadtype=[];
        this.select_priority = [];
        this.$emit("followupFilter", 'all');
        let self = this;
        let assigned_filter = 'all';
        let crm_id = this.select_assigned.id ;
        crm_id && crm_id != 'all' ? assigned_filter = 'crm' : assigned_filter = 'all';
        let selected_lead_tag = 0;
        selected_lead_tag = (this.selected_tags['id'] == 'all'  || this.selected_tags['id'] === undefined) ?  0:  this.selected_tags['id'];  
        this.$emit("assigned_filter", assigned_filter);
        this.$emit("crm_id", crm_id);
        this.$emit("changeColor", '');
        localStorage.setItem('software_filter', 'all');
        localStorage.setItem('demo_filter', 'all');
        this.$emit("selecttabe", this.selectTab);
        this.$store
          .dispatch("users/getAllDemoRequests", [
            1,
            "",
            this.selectTab,
            self.request_from,
            self.request_to,
            self.follow_up_from,
            self.follow_up_to,
            "",
            "",
            "",
            'all',
            'all',
            'all',
            assigned_filter,
            crm_id,
            selected_lead_tag
          ])
          .then( () =>  {
            this.skeletonLoader = false;
            this.$emit("skeletonLoader", this.skeletonLoader);
          });
      },





      software(event) {
        this.skeletonLoader = true;
        let selected_lead_tag = 0;
        selected_lead_tag = (this.selected_tags['id'] == 'all'  || this.selected_tags['id'] === undefined) ?  0:  this.selected_tags['id'];  
        this.$emit("skeletonLoader", this.skeletonLoader);
        let self = this;
        let software_filter = event.value;
        this.search = '';
        this.select_demo = [];
        this.select_leadtype=[];
        this.select_followUp = [];
        this.select_priority = [];
        this.select_assigned = [];
        if(software_filter == 0 || software_filter == 1 && this.selected_page != 1){
          this.selected_page = 1;
        }
        this.$emit("assigned_filter", 'all');
        this.$emit("crm_id", 0);
        this.$emit("changeColor", '');
        this.$emit("softwareFilter", software_filter);
        localStorage.removeItem("direction");
        localStorage.setItem("demo_filter", 'all');
        localStorage.setItem('software_filter', software_filter);

        this.$emit("selecttabe", this.selectTab);
        this.$store
          .dispatch("users/getAllDemoRequests", [
            this.selected_page,
            "",
            this.selectTab,
            self.request_from,
            self.request_to,
            self.follow_up_from,
            self.follow_up_to,
            "",
            "",
            "",
            'all',
            'all',
            software_filter,
            'all',
             0
          ])
          .then( () => {
            this.skeletonLoader = false;
            this.$emit("skeletonLoader", this.skeletonLoader);
          });
      },
      selTabe(event) {
        this.$emit("selecttabe", event);
      },
      demosBySearch() {
        setTimeout(() => {
          this.skeletonLoader = true;
          this.select_assigned = [];
          this.select_demo = [];
          this.select_software = [];
          this.select_followUp = this.filter_event;
          this.select_priority = [];
          this.select_leadtype = [];
          this.selected_tags = this.tag_options[0];
          this.$emit("skeletonLoader", this.skeletonLoader);

          this.$store.dispatch("users/getAllDemoRequests", [
            1,
            this.search,
            this.selectTab,
            "",
            "",
            "",
            "",
            "",
            "",
            this.select_priority.value,
            10,
            'all',
            'all',
            'all',
            '',
            "",
            this.filter_event.start_date,
            this.filter_event.end_date,
          ]).then(() => {
                this.skeletonLoader = false;
                this.$emit("skeletonLoader", this.skeletonLoader);
              });

        }, 1000);
      },
      demotabs(status) {
        if($( window ).width() >= 1280 && $( window ).width()<= 1366 && this.$route.fullPath.indexOf('/demo-leads') != -1){
          $(".table").css("width","1880px");
          $("table tr td:nth-child(1)").css("width","0.5%");
          $("table tr td:nth-child(2)").css("width","1%");
          $("table tr td:nth-child(3)").css("width","8%");
          $("table tr td:nth-child(4)").css("width","8.5%");
       
        }else if(this.$route.fullPath.indexOf('/demo-leads') != -1){
    
          $("table tr td:nth-child(1)").css("width","0.5%");
          $("table tr td:nth-child(2)").css("width","1%");
          $("table tr td:nth-child(3)").css("width","8%");
          $("table tr td:nth-child(4)").css("width","8.5%");
        }
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.search="";

        this.skeletonLoader = true;
        this.$emit("skeletonLoader", this.skeletonLoader);
        localStorage.removeItem("direction");
        localStorage.setItem("demo_filter", 'all');
        localStorage.setItem('software_filter', 'all');
        this.$emit("setStatus", status);
        ///////////////
        this.selected_page = 1;
        this.$emit("setPage", this.selected_page);
            this.$store.dispatch("users/getAllDemoRequests", [ this.selected_page, "", status, "", "", "", "", "", "", "", 'all', 'all', 'all','all','',0])
            .then(() => {
                    this.skeletonLoader = false;
                    this.$emit("skeletonLoader", this.skeletonLoader);
            });
          this.selectTab = status;
          this.select_priority=this.priority[0];
          this.select_followUp = this.short_term_filter[0];
          this.select_demo = this.demo_schedule[0];
          this.select_software = this.lead_software[0];
          this.selected_tags = this.tag_options[0];
          this.select_assigned= []; 
              this.$forceUpdate();
            // this.$store.dispatch("users/getAllDemoRequests", [1, "", status, "", "", "", "", "", "", "", 'all', 'all', 'all'])
            // .then(()=> {
            //   // loader.hide();
            //   // console.log(this.skeletonLoader);
            //   setTimeout(() => {
                 
            //         console.log("then",this.skeletonLoader)
            //     }, 100);
            // });
         
      },
      //////////////
      // setPage(page) {
      //   this.$emit("setPage", this.selected_page);
      // },

      clear() {
        this.results = "";
        this.search = "";
      },

      handleSearch: _.debounce(function () {
        this.preApiCall();
      }, 500),

      preApiCall() {
        if (cancel != undefined) {
          cancel();
        }
        this.apiCall(this.search);
      },

      apiCall(query) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.skeletonLoader = true;
        this.$emit("skeletonLoader", this.skeletonLoader);
        this.$store
          .dispatch("users/getAllDemoRequests", [
            this.selected_page,
            this.search,
            this.status,
            this.request_from,
            this.request_to,
            this.follow_up_from,
            this.follow_up_to,
            "",
            "",
            this.color,
            'all',
            'all',
            'all'
          ])
          .then(function () {
            // loader.hide();
            this.skeletonLoader = false;
          this.$emit("skeletonLoader", this.skeletonLoader);
          });
      },
      changeColor(event) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.skeletonLoader = true;
        this.$emit("skeletonLoader", this.skeletonLoader);
        this.$emit("assigned_filter", 'all');
        this.$emit("crm_id", 0);
        this.select_assigned = [];
         this.select_leadtype= [];
        this.select_demo = [];
        this.search = '';
        let selected_lead_tag = 0;
        selected_lead_tag = (this.selected_tags['id'] == 'all'  || this.selected_tags['id'] === undefined) ?  0:  this.selected_tags['id'];
        this.select_software = [];
        var color = event.value;
        if(event.value == 'all'){
          color = '';
        }
        localStorage.setItem('demo_filter', 'all');
        localStorage.setItem('software_filter', 'all');
        this.$emit("followupFilter", 'all');
        this.$emit("changeColor", color);
        this.$store
          .dispatch("users/getAllDemoRequests", [
            this.selected_page,
            "",
            this.selectTab,
            "",
            "",
            "",
            "",
            "",
            "",
            color ? color : "",
            this.select_followUp.value,
            'all',
            'all',
            'all',
            0, 
            selected_lead_tag           
          ])
          .then(() => {
            // loader.hide();
            this.skeletonLoader = false;
            this.$emit("skeletonLoader", this.skeletonLoader);
          });
        this.color = color;
      },
      leadTags(event){
        this.skeletonLoader = true;
        this.$emit("skeletonLoader", this.skeletonLoader);
        this.search = '';
        let assigned_filter = 'all';
        let crm_id = this.select_assigned.id ;
        crm_id && crm_id != 'all' ? assigned_filter = 'crm' : assigned_filter = 'all';
        this.select_priority.value == "all" ? this.select_priority.value = '' : '';
        let selected_lead_tag = 0;
        selected_lead_tag = (this.selected_tags['id'] == 'all'  || this.selected_tags['id'] === undefined) ?  0:  this.selected_tags['id'];
        this.$emit("leadTag", selected_lead_tag);
        this.$store
          .dispatch("users/getAllDemoRequests", [
            this.selected_page,
            "",
            this.selectTab,
            "",
            "",
            "",
            "",
            "",
            "",
            this.select_priority.value,
            this.select_followUp.value,
            this.select_demo.value,
            'all',
            assigned_filter,
            crm_id,  
            selected_lead_tag,
            this.short_term_filter[10].start_date,
            this.short_term_filter[10].end_date
          ])
          .then(() => {
            // loader.hide();
            this.skeletonLoader = false;
            this.$emit("skeletonLoader", this.skeletonLoader);
          }); 
      },
      createDemo() {
        this.$store.dispatch("modal/update", {
          action: "create",
          title: "Add Lead",
          formData: {
            status:this.status,
          },
          component: DemoForm,
        });
      },
      changeFilter() { },
      
    },
  };
</script>
<style scoped lang="scss">
 .btn:hover {
      background:  rgb(72, 166, 166) !important;
      .fa-filter,.fa-plus{
        color:white !important;
      }
  }
  // .btn:hover>.fa-filter{
  //   color:white !important;
  // }
  // .add-lead:hover{
  //   background: white !important;
  //   >.fa-plus{
  //     color: rgb(72, 166, 166) !important;
  //   }
    
  // }
</style>
<style>
  
  .demo-date {
    height: 35px;
    width: 100%;
    display: block;
    border-radius: 5px;
    border: 1px solid #e8e8e8;
    background: #fff;
    font-size: 14px;
    padding-top: 5px;
  }

  .dropdown-item {
    cursor: pointer;
  }

  #tabs .nav-link {
    background: transparent;
    color: rgb(66, 64, 64);
  }

  #tabs a:hover {}

  #tabs .active {
    background-color: #48a6a6 !important;
    color: white !important;
  }
  .filter-button{
    background-color: #f7f8f9;
    border-bottom: 1px solid #93a8d6;
    margin-bottom: 0;
  }
  /* .multiselect__element .multiselect__option--highlight {
    background: #48a6a6 !important;
  }
   */
  /* .multiselect__option.multiselect__option--highlight.multiselect__option--selected:after{
    background: #e7eef3 !important;
    color:black !important;
  }
  .multiselect__option--highlight:after{
    background: #e7eef3 !important;
    color:black !important;
  }
  .multiselect__option.multiselect__option--highlight.multiselect__option--selected{
      background: #3776a9 !important;
         /* color: #FFFFFF; */
  /* }  */
  .multiselect__placeholder {
      margin-bottom: 7px !important;
      padding-top: 0px !important;
  }
  
</style>